// Hand-authored inline SVGs rather than an icon font (e.g. Material Symbols)
// — the widget bundle is deliberately self-contained with zero external
// runtime requests (see docs/WidgetInstallation.md); pulling icon glyphs
// from Google Fonts would add exactly the kind of external dependency this
// project avoids. Each path uses currentColor so existing color/size CSS
// applies unchanged.
function createIcon(pathData: string, viewBox = '0 0 24 24'): SVGSVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', viewBox);
  svg.setAttribute('fill', 'none');
  svg.setAttribute('aria-hidden', 'true');
  svg.classList.add('flix-chat-widget__icon');

  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('d', pathData);
  path.setAttribute('stroke', 'currentColor');
  path.setAttribute('stroke-width', '1.8');
  path.setAttribute('stroke-linecap', 'round');
  path.setAttribute('stroke-linejoin', 'round');
  svg.append(path);

  return svg;
}

export function chatBubbleIcon(): SVGSVGElement {
  return createIcon(
    'M4 12a8 8 0 1 1 3.2 6.4L4 20l1.1-3.5A7.96 7.96 0 0 1 4 12Z',
  );
}

export function closeIcon(): SVGSVGElement {
  return createIcon('M6 6l12 12M18 6L6 18');
}

export function sendIcon(): SVGSVGElement {
  return createIcon('M4 12l16-7-6.5 16-2.3-6.2L4 12Zm0 0l7.2 2.3');
}

export function attachIcon(): SVGSVGElement {
  return createIcon(
    'M17 8.5l-7.6 7.6a3 3 0 1 1-4.24-4.24l8.3-8.3a4.5 4.5 0 1 1 6.36 6.36L11 18.7a2 2 0 1 1-2.83-2.83l7.6-7.6',
  );
}

export function refreshIcon(): SVGSVGElement {
  return createIcon(
    'M4 4v5h5M20 20v-5h-5M4.6 15a8 8 0 0 0 14.7 2.3M19.4 9A8 8 0 0 0 4.7 6.7',
  );
}

export function fileIcon(): SVGSVGElement {
  return createIcon(
    'M7 3h7l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm7 0v5h5',
  );
}

export function soundOnIcon(): SVGSVGElement {
  return createIcon(
    'M4 9.5v5h3.5L12 18.5v-13L7.5 9.5H4Zm11.2-.7a4 4 0 0 1 0 6.4M17.8 6a8 8 0 0 1 0 12',
  );
}

export function soundOffIcon(): SVGSVGElement {
  return createIcon(
    'M4 9.5v5h3.5L12 18.5v-13L7.5 9.5H4Zm11 .5 5 5m0-5-5 5',
  );
}

export function replyIcon(): SVGSVGElement {
  return createIcon('M9 7 4 12l5 5M4 12h9a7 7 0 0 1 7 7v0');
}

export function copyIcon(): SVGSVGElement {
  return createIcon(
    'M9 9h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1Zm-2 6H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v1',
  );
}

export function flagIcon(): SVGSVGElement {
  return createIcon('M5 21V4m0 1h11l-2 4 2 4H5');
}

export function uploadIcon(): SVGSVGElement {
  return createIcon(
    'M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5M5 20h14',
  );
}

export function bellIcon(): SVGSVGElement {
  return createIcon(
    'M6 10a6 6 0 1 1 12 0c0 3.2 1 4.8 1.6 5.6a1 1 0 0 1-.8 1.6H5.2a1 1 0 0 1-.8-1.6C5 14.8 6 13.2 6 10Zm3.5 10a2.5 2.5 0 0 0 5 0',
  );
}

export function bellOffIcon(): SVGSVGElement {
  return createIcon(
    'M6 10a6 6 0 0 1 5-5.92M14.6 5.4A6 6 0 0 1 18 10c0 3.2 1 4.8 1.6 5.6a1 1 0 0 1-.8 1.6H8m-3.8-1.6C5 14.8 6 13.2 6 10c0-.4 0-.8.1-1.2M3 3l18 18M9.5 20a2.5 2.5 0 0 0 5 0',
  );
}

export function clockIcon(): SVGSVGElement {
  return createIcon('M12 7.5V12l3 2M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z');
}

export function warningIcon(): SVGSVGElement {
  return createIcon(
    'M12 3.5 2.5 20h19L12 3.5ZM12 10v4.5M12 17.2v.1',
  );
}

export function lockIcon(): SVGSVGElement {
  return createIcon(
    'M7 10V7a5 5 0 0 1 10 0v3M6 10h12a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1Z',
  );
}

export function logoutIcon(): SVGSVGElement {
  return createIcon('M15 17l5-5-5-5M20 12H8M12 4H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6');
}

export function moreVertIcon(): SVGSVGElement {
  return createIcon('M12 6h.01M12 12h.01M12 18h.01');
}

export function personIcon(): SVGSVGElement {
  return createIcon('M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 8a7 7 0 0 1 14 0');
}

export function spinnerIcon(): SVGSVGElement {
  const svg = createIcon('M12 3a9 9 0 1 0 9 9');
  svg.classList.add('flix-chat-widget__icon--spin');
  return svg;
}

